var audio_rtlignore_default = {
  "fontElementMap": "Dv4XY",
  "container": "Rm5xM",
  "customPlayer": "DkQVu",
  "slim": "XXhoO",
  "playPauseButton": "kNMwS",
  "coverImage": "kiZE3",
  "trackDetailsContainer": "_7-haJ",
  "controlsContainer": "ReMwV",
  "controlsGroup": "ILFzU",
  "sliderContainer": "LNU6V",
  "audioDuration": "Rax24",
  "isLoading": "aF1ox",
  "audioIconButton": "Xhg5d",
  "audioVolumeWrapper": "A5lIa",
  "volumeSliderWrapper": "mQLaf",
  "audioDetails": "frhpq",
  "authorName": "YZrKd",
  "title": "_08Pyi",
  "audioContextMenuWrapper": "-IaVA",
  "dropdownMenuWrapper": "jDvWQ",
  "dropdownSelectedButton": "yxopW",
  "dropdownContent": "_31xtz",
  "dropdownContentWithIcon": "u8rDA",
  "audioLoader": "F9Z-5"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
